<a href="#" id="clear-action-plan-responses" class="btn btn-primary {{#if noResponses}}disabled{{/if}}">Clear All Responses</a>
<p>Current Responses:</p>
<pre>
  {{responses}}
</pre>
